function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgMultiSelectButton(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    ry: 4.5,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), React.createElement("path", {
    d: "m27,1c2.21,0,4,1.79,4,4v22c0,2.21-1.79,4-4,4H5c-2.21,0-4-1.79-4-4V5C1,2.79,2.79,1,5,1h22m0-1H5C2.24,0,0,2.24,0,5v22c0,2.76,2.24,5,5,5h22c2.76,0,5-2.24,5-5V5c0-2.76-2.24-5-5-5Z",
    style: {
      fill: "#0074d9",
      strokeWidth: 0
    }
  }), React.createElement("path", {
    d: "m17.83,19.34h-.2c-.77-.02-1.48.45-1.74,1.18l-1.56,4.1-1.22-4c-.22-.74-.89-1.25-1.66-1.28h0c-1.34,0-2.42-1.09-2.41-2.43,0,0,0,0,0-.01v-6.84c-.02-1.33,1.05-2.42,2.38-2.44,0,0,0,0,.01,0h6.4c1.33.01,2.4,1.1,2.39,2.43,0,0,0,0,0,.01v6.84c.01,1.33-1.06,2.42-2.39,2.44Z",
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("rect", {
    x: 12.54,
    y: 11.49,
    width: 4.1,
    height: 4.18,
    rx: 1.09,
    ry: 1.09,
    style: {
      fill: "none",
      stroke: "#636569",
      strokeMiterlimit: 10
    }
  }), React.createElement("path", {
    d: "m21.81,8.76c.95.36,1.58,1.28,1.57,2.3v6.84c.01,1.33-1.06,2.42-2.39,2.44h-.22c-.77-.02-1.47.45-1.74,1.18l-1.54,4.11-.86-2.83",
    style: {
      fill: "none",
      stroke: "#636569",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}

export default __webpack_public_path__ + "static/media/multiSelectButton.8424fc4e.svg";
export { SvgMultiSelectButton as ReactComponent };